import CryptoJS from "crypto-js";
import React, { Component } from "react";
import { withRouter } from "react-router";
import AuthService from "../../session/AuthService";
import "./Login.css";

import {
  getnotificationCount,
  userLogined,
} from "../../redux/actions/MangeUserProfileAction";
import { connect } from "react-redux";
import FarmShopConnectLogo from "../../images/FarmShopConnectLogo.png";
import LoginService from "../../api/LoginService";
import { Toaster, toast } from "react-hot-toast";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import playstore from "../../images/playstore.png";
import appstore from "../../images/appstore.png";
import ManageUserService from "../../api/ManageUserService";
import moment from "moment";

var IPdress = "";
class LoginContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      hasLoginFailed: false,
      message: false,
      langValue: "en",
      Forget: false,
      isSignUp: false,
      showPassword: "password",
      rememberMe: false,
    };
  }

  onOpenSignUp = () => {
    this.setState({
      isSignUp: !this.state.isSignUp,
    });
  };
  componentDidMount() {
    user_location();

    if (AuthService.isAuth()) {
      if (AuthService.getUserTypeAdmin() === "1") {
        this.props.history.push(`/Tasks`);
      } else {
        this.props.history.push(`/home`);
      }
    }
  }

  render() {
    return (
      <>
        <div className="login-page">
          <div className="logo-container-in-loginpage">
            <img src={FarmShopConnectLogo} alt="Logo" className="logo" />
          </div>
          <div className="login-card">
            <h4 style={{ fontWeight: 700, color: "#292929" }}>Login</h4>
            <p style={{ color: "#545454" }}>Enter your credentials below:</p>

            <input
              type="text"
              placeholder="Email Address"
              onChange={this.handleChange}
              name="email"
              value={this.state.email}
              onKeyDown={this.handleKeyDown}
            />
            <input
              type="password"
              placeholder="Password"
              onChange={this.handleChange}
              name="password"
              value={this.state.password}
              className="password-input"
              onKeyDown={this.handleKeyDown}
            />
            <div className="button-allign">
              <button
                type="button"
                className="btn btn-success"
                onClick={this.loginClick}
                style={{ fontFamily: "Karla" }}
              >
                Log In
              </button>
            </div>

            <div className="centre-the-div">
              <span className="forgot-password-text" onClick={this.openForgot}>
                Forgot Password
              </span>

              <span
                className="first-time-user"
                onClick={this.handleFirstTimeUserClick}
              >
                First Time User?
              </span>
            </div>
          </div>
          <Row className="p-2">
            <Col xs={12}>
              <p className="my-2" align="center">
                Get the app.
              </p>
            </Col>
            <Col
              xs={6}
              className="d-flex align-items-center justify-content-center"
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/in/app/farm-shop-connect/id6470219426"
              >
                <img
                  src={appstore}
                  alt="Download on App Store"
                  className="responsive-ref-ios"
                  loading="lazy"
                />
              </a>
            </Col>
            <Col
              xs={6}
              className="d-flex align-items-center justify-content-center"
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.farmshopconnect.mobileapp"
              >
                <img
                  src={playstore}
                  alt="Download on Play Store"
                  className="responsive-ref-android"
                  loading="lazy"
                />
              </a>
            </Col>
          </Row>
          <div className="footer-query">
            <p align="center" className="m-0">
              Having any issues?
            </p>
            <p align="center" className="m-0">
              Contact us at{" "}
              <span><a className="forgot-password-text" href="mailto:support@farmshopconnect.com">
                support@farmshopconnect.com
              </a></span>
            </p>
          </div>
        </div>
        <Toaster />
      </>
    );
  }

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Prevent the default Enter key behavior (e.g., submitting a form)
      event.preventDefault();

      // Call the openOtp function
      this.loginClick();
    }
  };

  handleFirstTimeUserClick = () => {
    this.props.history.push("/forgotPassword");
    AuthService.storeStateofLoginPage("firstTimeUser");
  };

  handleRememberMeChange = () => {
    this.setState({
      rememberMe: !this.state.rememberMe,
    });
  };

  openForgot = () => {
    this.props.history.push("/forgotPassword");
    AuthService.storeStateofLoginPage("forgotPassword");
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  loginClick = (e) => {
    if (!this.state.email) {
      toast.error("Please Enter a Valid Email");
    } else if (!this.state.password) {
      toast.error("Please Enter Password");
    } else {
      var navi =
        navigator.userAgent +
        " & " +
        navigator.vendor +
        " & " +
        navigator.language;
      var encript = CryptoJS.MD5(this.state.password).toString();
      var loginUser = {
        email: this.state.email,
        password: encript,
        SystemDetails: navi,
        ipAddress: IPdress,
        navication: navi,
      };

      LoginService.getLogin(loginUser)
        .then((response) => {
          console.log("response", response.data.data);
          var result = response.data;

          if (response.data.data.loginStatus === "SUCCESS") {
            AuthService.registerAuth(result.data);
            AuthService.storeIpAddress(IPdress);
            AuthService.registerToken(result.data.token);

            if(response.data.data.userType === "3" || window.location.hostname === "localhost"){
              this.moveToUsersAuthorizedPage();
            }else{
              // this.moveToUsersAuthorizedPage();
              this.checkSubscriptionStatus();
            }
          } else if (response.data.data === "INCORRECT_PASSWORD") {
            toast.error("Please Enter Valid  Password");
            this.setState({
              password: "",
            });
          } else if (response.data.data === "EMAIL_NOT_EXISTS") {
            toast.error("Please Enter Valid Email");
            this.setState({
              email: "",
              password: "",
            });
          } else if (response.data.data === "ADMIN_ONLY_ALLOWED") {
            toast.error("Only Owner Can Login");
            this.setState({
              email: "",
              password: "",
            });
          } else {
            toast.error("Something Went wrong");
            this.setState({
              email: "",
              password: "",
            });
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("Network error, Please try again later");
          this.setState({ message: false });
          this.setState({ hasLoginFailed: true });
        });
    }
  };

  moveToUsersAuthorizedPage = () => {
    if (AuthService.getUserId() !== null) {
      console.log("OBJ:::before", AuthService.getUserId());

      this.props.userLogined(true);
      this.props.getnotificationCount();
      AuthService.getUserTypeAdmin() === "1"
        ? this.props.history.push(`/Employee`)
        : this.props.history.push(`/Employers`);
    } else {
      this.props.history.push(`/`);
    }
  };

  checkSubscriptionStatus = () => {
    const obj = {
      id: AuthService.getUserId(),
    };

    ManageUserService.checkSubscriptionStatus(obj)
      .then((response) => {
        if (response.data.status === 1) {
          const { platform, latestReceipt } = response.data.data;

          if (platform === "android") {
            const parsedData = JSON.parse(latestReceipt);
            const expiryDate = new Date(parseInt(parsedData.expiryTimeMillis));

            if (moment(expiryDate).isAfter()) {
              this.moveToUsersAuthorizedPage();
              console.log("The subscription is still active.");
            } else {
              this.handleSubscriptionExpired();
              this.props.history.push(`/Nosubscription`);
            }
          } else if (platform === "ios") {
            // alert("ios");
            // console.log("The subscription is still active", response.data.data.);
            const expiryDate = new Date(
              parseInt(latestReceipt.expires_date_ms)
            );
            // console.log("The subscription is still active", expiryDate);
            const currentDate = new Date();

            if (expiryDate > currentDate) {
              this.moveToUsersAuthorizedPage();
              console.log("The subscription is still active.");
            } else {
              console.log("The subscription has expired.");
              this.handleSubscriptionExpired();
            }
          } else {
            console.log("Unknown platform error.");
            AuthService.removeAuth();
          }
        } else if (response.data.status === -2) {
          console.log("Error validating subscription.");
          toast.error("No Active Subscription.");
          AuthService.removeAuth();
          this.props.history.push(`/Nosubscription`);
        } else if (response.data.status === -1) {
          console.log("Error validating subscription.");
          toast.error("No Active Subscription.");
          this.handleSubscriptionExpired();
        } else {
          console.log("Unknown error:", response);
          this.handleSubscriptionExpired();
          // this.props.history.push(`/Nosubscription`);
        }
      })
      .catch((error) => {
        console.error("Network error:", error);
        toast.error("Network error. Please try again later.");
      });
  };
  handleSubscriptionExpired = () => {
    AuthService.removeAuth();
    this.props.history.push("/Nosubscription");
  };
}

function user_location() {
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      IPdress = this.responseText;
    }
  };
  xhttp.open("GET", "//api.ipify.org?format=json", true);
  xhttp.send();
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = function (dispatch) {
  return {
    userLogined: (data) => dispatch(userLogined(data)),
    getnotificationCount: () => dispatch(getnotificationCount()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LoginContainer));
